module.exports = __webpack_public_path__ + "static/media/vk.57656a6a.svg";